<template lang="pug">
  #organization-navigator
    WtButton(
      isRouterLink
      :to="{ name: 'TeamCenterSettings' }"
      :color="$route.path.includes('/admin/team-center/teams-settings') ? 'primary': 'white'"
      :class="!$route.path.includes('/admin/team-center/teams-settings') ? 'inactive-route': null"
    ) Teams
    WtButton.ml-4(
      isRouterLink
      :to="{ name: 'OrganizationsCenterSettings' }"
      :color="$route.path.includes('/admin/team-center/organizations-settings') ? 'primary': 'white'"
      :class="!$route.path.includes('/admin/team-center/organizations-settings') ? 'inactive-route': null"
    ) Organizations
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "OrganizationsTeamsNavigator",

  components: { WtButton }
};
</script>

<style lang="sass">
#organization-navigator
  .inactive-route
    color: $grey-light
    border-color: $grey-light
</style>
